import { render, staticRenderFns } from "./StatisticListItem.vue?vue&type=template&id=e8d78dd2&"
import script from "./StatisticListItem.vue?vue&type=script&lang=js&"
export * from "./StatisticListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports